export const getters = {
  systemJobcards: state => state.jobcards,
  Jobcard: state => state.systemJobcard
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/jobcards/getters.js